import {MUIContainer} from '@/components/MUI-Components';
import {CONTACT_US_DATA} from '@/util/metaData/company';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import dynamic from 'next/dynamic';
import PageHead from '@/components/PageHead';
import {colors, fontSize, fontWeight, gradients, lineHeight} from '@/styles/tokens';
// Server-rendered: loaded client-side only, the ~510px form appeared after load and pushed the rest of the
// page down (layout shift). Still its own chunk; the pop-up dialogs elsewhere keep loading it on demand.
const ContactPageForm = dynamic(() => import('@/components/Ui-components/contact-page-form'));

// ─── sx objects — module-level constants ──────────────────────────────────────
// Migrated from globals.scss `.contact-us` (sole consumer) + mobileScreen
// (max-width:430px, shared group) breakpoint override.
const contactUsHeadingSx = {
    fontSize: '55px !important', // no exact tokens.ts match
    color: colors.text.inverse,
    fontWeight: `${fontWeight.bold} !important`,
    '@media (max-width: 430px)': {fontSize: '26px !important', lineHeight: `${lineHeight[40]} !important`} // no exact fontSize token match
} as const;

// Migrated from globals.scss `.contact-us-subtext` (sole consumer) + nested `span` +
// mobileScreen (max-width:430px, shared group) breakpoint override.
const contactUsSubtextSx = {
    fontSize: `${fontSize[20]} !important`,
    color: colors.text.inverse,
    fontWeight: `${fontWeight.regular} !important`,
    '@media (max-width: 430px)': {
        fontSize: `${fontSize[18]} !important`,
        textAlign: 'left !important',
        lineHeight: '30px !important', // no exact tokens.ts match
        '& span': {fontSize: `${fontSize[18]} !important`}
    }
} as const;
// ─── getStaticProps ─────────────────────────────────────────────────────────
export const getStaticProps = async () => {
    const {contactStepData} = await import('@/util/contents/contact-us');

    return {
        props: {
            contactStepData
        }
    };
};

const Testimonials = dynamic(import('@/components/Ui-components/Testimonials'));
const HomeBusiness = dynamic(() => import('@/components/Ui-components/home/home-business'));

const ContactUs = (props: any) => {
    const {contactStepData} = props;
    return (
        <Box className="contact-us-main-parent">
            <PageHead meta={CONTACT_US_DATA} url="/contact-us" />

            <Box className="contact-us-content" sx={{background: gradients.primaryActive, textAlign: 'center'}}>
                <MUIContainer>
                    <Typography component="h1" className="contact-us top-space" sx={contactUsHeadingSx}>
                        Contact Us
                    </Typography>
                    <Typography className="contact-us-subtext bottom-spacing" sx={contactUsSubtextSx}>
                        Got a project in mind? Let us quote it for you!
                    </Typography>
                </MUIContainer>
            </Box>
            <Box className="bottom-spacing top-spacing">
                <MUIContainer>
                    <ContactPageForm />
                </MUIContainer>
            </Box>

            <Box className="top-space mobile-top-padding bottom-spacing mobile-padding-bottom bg-blue-background">
                <HomeBusiness heading="We Exceed Expectations Without Compromising Quality" contentData={contactStepData} />
            </Box>
            <Grid item xs={12}>
                <Box>
                    <Testimonials heading="Our Clients Describe Us Best" />
                </Box>
            </Grid>
        </Box>
    );
};
export default ContactUs;
ContactUs.Layout = 'Contact';
